import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { http } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = verificando, false = não autenticado

  const check = useCallback(async () => {
    try {
      const { data } = await http.get("/auth/me");
      setUser(data);
    } catch {
      try {
        await http.post("/auth/refresh");
        const { data } = await http.get("/auth/me");
        setUser(data);
      } catch {
        setUser(false);
      }
    }
  }, []);

  useEffect(() => { check(); }, [check]);

  const login = async (username, password) => {
    const { data } = await http.post("/auth/login", { username, password });
    setUser(data);
  };

  const logout = async () => {
    try { await http.post("/auth/logout"); } finally { setUser(false); }
  };

  return <AuthCtx.Provider value={{ user, login, logout, setUser }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
